<template id="view">
  <div id="article" class="container">
    <section>
      <div class="row" v-if="Article != null">
        <div class="col-lg-9 pr-lg-4">
          <!-- 文章內容 -->

          <div class="article-view section-group">
            <div class="card p-3 p-sm-4 p-md-5">
              <h2 class="title mb-2">{{ Article.sgL_Title }}</h2>
              <div class="subrow mt-2">
                <div class="publisher mr-2">
                  <a target="_blank" href="" :title="Article.sgL_DisplayName"
                    ><img class="user-logo mr-1" :src="userlogo" />
                    {{ Article.sgL_DisplayName }}
                  </a>
                </div>
                <div class="date">{{ $t('Topic.articleview.MSG') }}{{ Article.sgL_CreateTimeM }}</div>
                <ul class="action">
                  <!-- <li class="like" title="讚好">
                    <a href=""> <i class="far fa-thumbs-up mr-1"></i> 讚好 </a>
                  </li> -->
                  <li class="bookmark ml-4" :title="$t('Topic.articleview.Collection')">
                    <a
                      href="javascript:void(0)"
                      @click="
                        addfavorite(Article.id, Article.sgL_MasterSort, 4, null)
                      "
                      ><i
                        class="fas fa-bookmark fa-fw"
                        v-if="Article.isCollection"
                      ></i
                      ><i class="far fa-bookmark fa-fw" v-else></i
                    ></a>
                  </li>

                  <li class="share ml-4" :title="$t('Topic.articleview.share')">
                    <!-- <a href=""> <i class="fa fa-share mr-1"></i> 分享 </a> -->
                    <!-- <ShareNetwork
                      network="facebook"
                      :url="shareurl"
                      title
                      description
                      :quote="Article.sgL_Title"
                      :hashtags="Article.sgL_Title"
                    >
                      <i class="fa fa-share mr-1"></i> 分享
                    </ShareNetwork> -->
                    <a
                      target="_blank"
                      :href="`https://www.facebook.com/sharer/sharer.php?src=sdkpreparse&amp;u=${shareurl}`"
                      style="color: #292c32"
                      @click="addShareCount()"
                    >
                      <i class="fa fa-share mr-1"></i> {{ $t('Topic.articleview.share') }}</a
                    >
                  </li>
                  <!-- <li class="report ml-4" title="檢舉">
                    <a href=""> <i class="fa fa-flag mr-1"></i> 檢舉 </a>
                  </li> -->
                </ul>
              </div>
              <hr class="divider" />
              <div class="content mb-4 ql-editor" v-html="Article.sgL_Content">

              </div>
              <div
                class="article-source my-2"
                v-if="Article.sgL_ReprintedSourceTitle != null"
              >
                {{ $t('Topic.articleview.sgL_ReprintedSourceTitle') }}<a
                  v-if="
                    Article.sgL_ReprintedSourceUrl != '' &&
                    Article.sgL_ReprintedSourceUrl != null
                  "
                  :href="Article.sgL_ReprintedSourceUrl"
                  >{{ Article.sgL_ReprintedSourceTitle }}</a
                >
                <span v-else>{{ Article.sgL_ReprintedSourceTitle }}</span>
              </div>
              <div class="article-category my-2">
                {{ $t('Topic.articleview.Type') }}<a href="">{{ Article.sgL_MasterSortF }}</a>
              </div>
              <div
                class="tag-line mt-1"
                v-if="
                  Article.sgL_NKeywordF != null && Article.sgL_NKeywordF != ''
                "
              >
                {{ $t('Topic.articleview.key') }}<span  v-for="tag in Article.sgL_NKeywordF"  :key="tag.id">
                  <a
                  class="tag"
                  href=""
                 
                 
                  v-if="tag != ''"
                  >{{ tag }}</a
                >
                </span>
              </div>
              <hr class="divider" />
              <!-- <div
                class="fb-comments"
                :data-href="`https://m.soonnet.org/videowatch/15837/video`"
                data-numposts="5"
                data-width
              ></div> -->

              <div>
                <userCommentsVue
                  :props_qryParams="commentsParams"
                  ref="comment"
                  @submitComment="submitComment"
                  @submitComment2="submitComment2"
                ></userCommentsVue>
              </div>
            </div>
          </div>
          <!-- ./文章內容 -->
        </div>
        <div class="col-lg-3">
          <!-- 廣告 -->
          <div class="section-group">
            <div class="row">
              <div class="col-12">
                <!-- <ins
                  class="adsbygoogle"
                  style="display: inline-block; width: 300px; height: 250px"
                  data-ad-client="ca-pub-8370308321819212"
                  data-ad-slot="7350126089"
                ></ins> -->
                <N2Vue></N2Vue>
              </div>
            </div>
          </div>
          <!-- ./廣告 -->

          <!-- 相關文章 -->
          <div class="related-article section-group">
            <h2 class="side-title">{{ $t('Topic.articleview.might') }}</h2>
            <div
              class="article-card card mb-1"
              v-for="maybe in MaybeList"
              :key="maybe.id"
            >
              <!-- <router-link
                target="_blank"
                v-bind:to="{
                  name: 'articleview',
                  params: {
                    id: maybe.id,
                  },
                }"
              > -->
              <a href="#" @click="otherTopic(maybe.id)">
                <div class="article-block">
                  <div class="article-thumbnail">
                    <div class="article-responsive">
                      <div class="article-sizer">
                        <div
                          class="article-image"
                          :style="{
                            backgroundImage:
                              'url(' + `${maybe.sgL_ImageUrl}` + ')',
                          }"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="article-info p-2">
                  <div class="article-title">{{ maybe.sgL_Title }}</div>
                </div>
              </a>
              <!-- </router-link> -->
            </div>
          </div>
          <!-- /.相關文章 -->
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import bases from "../../api/httpApi/base";
import "../../../node_modules/vue-social-sharing/dist/vue-social-sharing.js";
import { Message } from "element-ui";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import userCommentsVue from "../common/userComments.vue";
import N2Vue from "../Ad/N2.vue";

export default {
  data() {
    return {
      base: null,
      shareurl: location.href,
      ArticleId: null,
      MaybeList: null,
      userlogo: "https://api.soonnet.org/Userlogo_Smail.jpg",
      Article: null,
      commentsParams: {
        SGL_PG_Coid: this.$route.query.id,
        SGL_Msg_Type: 2,
      },
    };
  },
  components: {
    userCommentsVue,
    N2Vue,
  },
  watch: {
    ArticleId(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.getArticleById();
      }
    },
    "Article.sgL_Title": {
      handler: function (newval, oldval) {
        document.title = newval + " - 尋寶網";
      },
    },
  },
  created() {
    this.base = bases;
    this.ArticleId = this.$route.query.id;
    this.getArticleById();
    this.pageViews();
    this.$store.dispatch("updateCurrentIndex", 10);
  },
  mounted() {
    // let _this = this;
    // window.onscroll = function () {
    //   _this.myFunction();
    // };
  },
  beforeUpdate() {
    $(".ql-video").wrap('<div class="videoWrapper"/>');
  },
  updated() {
    let ss = document.getElementsByClassName("ql-video");
    let list = Array.from(ss);

    list.forEach((res) => {
      // res.addClass("videoSize");
      // res.classList.add("videoWrapper");
      // res.setAttribute("style", " width: 100%;height: 100%;");
    });
  },

  destroyed() {
    window.onscroll = function () {};
    document.getElementById("progressBar").style.width = 0 + "%";
  },
  methods: {
    submitComment(data) {
      let params = {
        sgL_PG_CBigsort: this.Article.sgL_MasterSort,
        sgL_PG_Coid: this.commentsParams.SGL_PG_Coid,
        sgL_Msg_Type: this.commentsParams.SGL_Msg_Type,
        sgL_Msg_MContent: data,
        sgL_Msg_SendType: 0,
        SGL_Mem_FinallyReceive_Cid: this.Article.sgL_UserId,
      };
      this.$refs.comment.submit(params);
    },
    submitComment2(
      data,
      sgL_Msg_ReplyMsgid,
      sgL_Mem_FinallyReceive_Cid,
      sgL_Mem_Reply_Cid
    ) {
      let params = {
        sgL_PG_CBigsort: this.Article.sgL_MasterSort,
        sgL_PG_Coid: this.commentsParams.SGL_PG_Coid,
        sgL_Msg_Type: this.commentsParams.SGL_Msg_Type,
        sgL_Msg_MContent: data,
        sgL_Msg_ReplyMsgid: sgL_Msg_ReplyMsgid,
        sgL_Mem_FinallyReceive_Cid: sgL_Mem_FinallyReceive_Cid,
        sgL_Mem_Reply_Cid: sgL_Mem_Reply_Cid,
        sgL_Msg_SendType: 1,
      };
      this.$refs.comment.submit(params);
    },
    otherTopic(id) {
      this.$router.push({ name: "articleview", query: { id: id } });
      this.ArticleId = id;
      this.pageViews();
    },
    pageViews() {
      let params = {};
      params[this.ArticleId] = "10";
      this.$api.TopicApi.pageViews(params);
    },
    addShareCount() {
      let params = {};
      params[this.ArticleId] = "50";
      this.$api.TopicApi.pageViews(params);
    },
    setMeta(model) {
      this.shareurl = escape(
        this.base.url +
          "/Home/facebookResp?id=" +
          model.id +
          "&type=articleview"
      );
    },
    trimHtml(str) {
      str = str.replace(/(\n)/g, "");
      str = str.replace(/(\t)/g, "");
      str = str.replace(/(\r)/g, "");
      str = str.replace(/<\/?[^>]*>/g, "");
      str = str.replace(/\s*/g, "");
      str = str.replace(/<[^>]*>/g, "");
      return str;
    },
    setMetas(model) {
      let initMeta = {
        keywords: model.sgL_NKeyword,
        description: this.trimHtml(model.sgL_Content).slice(0, 70),
        thumbnail: model.sgL_ImageUrl,
      };
      let head = document.getElementsByTagName("head");
      let meta = document.createElement("meta");
      document
        .querySelector('meta[name="keywords"]')
        .setAttribute("content", initMeta.keywords);
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", initMeta.description);
      document
        .querySelector('meta[name="thumbnail"]')
        .setAttribute("content", initMeta.thumbnail);
      meta.content = initMeta;
      head[0].appendChild(meta);
    },
    getHtmlContent(str) {
      str = str.replace(/&lt;/g, "<");
      str = str.replace(/&gt;/g, ">");
      return str;
    },
    getArticleById() {
      let params = {
        id: this.ArticleId,
      };
      this.$api.TopicApi.GetArticleDesk(params).then((res) => {
        if (res.data.success) {
          this.Article = res.data.result;
          this.Article.sgL_Content = this.Article.sgL_Content.replace(
            'href="www.',
            'href="http://www.'
          );
          this.Article.sgL_Content = this.getHtmlContent(
            this.Article.sgL_Content
          );
          this.userlogo = this.Article.userLogoSmail;
          this.setMeta(this.Article);
          this.getMaybeList();
          this.setMetas(this.Article);
        }
      });
    },
    addfavorite(tid, type, Ftype, longid) {
      //判断是否登陆，无登陆，则提示，不跳转
      if (this.$store.getters.getcustomer == null) {
        this.$message({
          message: "請先進行登錄",
        });
        return;
      }
      let params = {
        sgL_DevicesType: 0,
        sgL_MasterSort: type, //类型
        sgL_PG_Coid: tid, //图册、影片、文章、活动的id
        sgL_Fav_FType: Ftype, //图册：0，图片：1，影片：2,文章：4，活动：3
        sgL_Fav_FBelongidc: longid, //图片id
      };
      this.$store.dispatch("addfavorite", params).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.getArticleById();
          // if (Ftype == 0) {
          //   this.getPicturePublish();
          // } else if (Ftype == 2) {
          //   this.getVideoPublish();
          // }
        }
      });
    },
    getMaybeList() {
      let params = {
        keyworlds: this.Article.sgL_NKeywordF,
        MaxResultCount: 10,
      };
      this.$api.TopicApi.GetArticleListDesk(params).then((res) => {
        if (res.data.success) {
          this.MaybeList = res.data.result.items;
        }
      });
    },
    myFunction() {
      var winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;
      var height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      var scrolled = (winScroll / height) * 100;
      document.getElementById("progressBar").style.width = scrolled + "%";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Topic/articleview.vue